export default __webpack_public_path__ + "static/SignUp-90c1207cdad7a05f7d6caf41a6f0af2e.webp";